import axios from "axios";
import Cookies from "js-cookie";

const token = Cookies.get("harvestera_security");

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  },
});

axiosClient.interceptors.request.use(
  async (config) => {
    try {
      const token = Cookies.get("harvestera_security");

      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      } else {
        config.headers["Authorization"] = "";
      }
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (err) => {
    return Promise.reject(err);
  },
);

// axiosClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.log("AXIOS INTERCEPTOR ERROR:", error);
//     console.log("STATUS:", error?.response?.status);

//     if (error?.response?.status === 401) {
//       console.log("401 FOUND - REMOVING COOKIE");

//       Cookies.remove("harvestera_security", { path: "/" });

//       console.log("COOKIE AFTER REMOVE:", Cookies.get("harvestera_security"));

//       window.location.replace("/");
//     }

//     return Promise.reject(error);
//   },
// );

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("AXIOS INTERCEPTOR ERROR:", error);
    console.log("STATUS:", error?.response?.status);
    if (error?.response?.status === 401) {
      const token = Cookies.get("harvestera_security");
      // Only redirect if a logged-in user actually had a token.
      if (token) {
        console.log("401 FOUND - REMOVING COOKIE");
        Cookies.remove("harvestera_security", { path: "/" });
        console.log("COOKIE AFTER REMOVE:", Cookies.get("harvestera_security"));
        window.location.replace("/");
      }
    }
    return Promise.reject(error);
  },
);

export default axiosClient;
